import React from 'react';
import { FaCode, FaMicrochip, FaCog, FaServer, FaDatabase, FaCloud } from 'react-icons/fa';

const TechLoader = ({ size = 'default', text = 'Loading...' }) => {
  const getSize = () => {
    switch (size) {
      case 'small':
        return 'h-4 w-4';
      case 'large':
        return 'h-8 w-8';
      case 'xl':
        return 'h-12 w-12';
      default:
        return 'h-6 w-6';
    }
  };

  const getContainerSize = () => {
    switch (size) {
      case 'small':
        return 'h-20 w-20';
      case 'large':
        return 'h-40 w-40';
      case 'xl':
        return 'h-60 w-60';
      default:
        return 'h-32 w-32';
    }
  };

  const iconSize = getSize();
  const containerSize = getContainerSize();

  return (
    <div className={`flex flex-col items-center justify-center ${containerSize}`}>
      <div className="relative w-full overflow-hidden">
        {/* Main rotating cog */}
        <div className="absolute inset-0 flex items-center justify-center animate-spin-slow">
          <FaCog className={`${iconSize} text-indigo-500`} />
        </div>
        
        {/* Horizontal sliding icons */}
        <div className="relative flex items-center justify-center animate-slide">
          <div className="flex space-x-4">
            <FaCode className={`${iconSize} text-blue-500 animate-float`} />
            <FaMicrochip className={`${iconSize} text-green-500 animate-float delay-75`} />
            <FaServer className={`${iconSize} text-purple-500 animate-float delay-100`} />
            <FaDatabase className={`${iconSize} text-red-500 animate-float delay-150`} />
            <FaCloud className={`${iconSize} text-cyan-500 animate-float delay-200`} />
          </div>
        </div>

        {/* Background cogs */}
        <div className="absolute top-0 left-0 animate-spin-slow opacity-20">
          <FaCog className={`${iconSize} text-gray-500`} />
        </div>
        <div className="absolute bottom-0 right-0 animate-spin-slow opacity-20">
          <FaCog className={`${iconSize} text-gray-500`} />
        </div>
      </div>
      
      {/* Loading text */}
      <div className="mt-8 text-gray-600 dark:text-gray-300 animate-pulse text-center">
        <span className={`${size === 'xl' ? 'text-xl' : 'text-base'}`}>{text}</span>
      </div>
    </div>
  );
};

export default TechLoader; 